<div class="tw-relative tw-flex-1 tw-pt-4">
  <div
    class="tw-absolute tw-left-0 tw-top-0 tw-flex tw-h-full tw-items-center tw-justify-center"
  >
    <da-icon
      icon="magnifying-glass"
      type="solid"
      [solidSize]="16"
      class="tw-absolute tw-left-3 tw-top-5 tw-mt-1 tw-block tw-size-4 tw-align-middle tw-text-neutral-600"
    />
  </div>
  <input
    #searchInput
    type="search"
    role="combobox"
    autocomplete="off"
    [attr.id]="'user-search'"
    [attr.aria-label]="ariaLabel"
    [class]="{ 'tw-rounded-none tw-border-0 tw-border-b-[1px]': isOpen() }"
    class="tw-flex tw-h-8 tw-w-full tw-justify-center tw-rounded-lg tw-border !tw-border-neutral-300 tw-bg-white tw-p-[12px] tw-px-9 tw-text-neutral-800 !tw-placeholder-neutral-600 placeholder:tw-not-italic placeholder:tw-text-neutral-600 focus:tw-rounded-none focus:tw-border-0 focus:tw-border-b-[1px]"
    [placeholder]="placeHolderLabel"
    data-dgat="user-search-354"
    (keyup)="onSearchQuery($event)"
    (focus)="onFocus()"
    (keydown)="onEscape($event)"
  />
  @if (showClearButton()) {
    <div
      class="tw-absolute tw-right-0 tw-top-0 tw-flex tw-h-full tw-items-center tw-justify-center"
    >
      <button
        type="button"
        class="tw-btn-icon tw-btn-tertiary-neutral tw-absolute tw-right-3 tw-top-5"
        [attr.aria-label]="translate('Clear', 'Core_Clear')"
        (click)="clearSearch()"
      >
        <da-icon
          icon="x-mark"
          type="solid"
          [solidSize]="16"
          class="tw-size-4 tw-text-neutral-600"
        ></da-icon>
      </button>
    </div>
  }
  <ul
    #dropdown
    cdkScrollable
    [class]="{ 'tw-hidden': !isOpen() }"
    role="listbox"
    tabindex="0"
    (keydown)="onDropdownKeyDown($event)"
    class="tw-absolute tw-z-10 tw-max-h-64 tw-w-full tw-overflow-auto tw-rounded-lg tw-rounded-t-none tw-border tw-border-solid tw-border-transparent tw-bg-white tw-px-3 tw-shadow-lg"
  >
    @if (isLoading()) {
      <li>
        <df-spinner
          [isSpinning]="true"
          class="tw-items-center tw-justify-center tw-py-2 tw-text-neutral-600"
        ></df-spinner>
      </li>
    } @else if (searchResults().length) {
      @for (searchItem of searchResults(); track searchItem) {
        <li
          role="option"
          [tabindex]="activeIndex() === $index ? 0 : -1"
          class="tw-cursor-pointer hover:tw-bg-neutral-100"
        >
          <dgx-user-search-item-v3
            [item]="searchItem"
            [isActive]="activeIndex() === $index"
            (click)="onItemSelect(searchItem)"
          ></dgx-user-search-item-v3>
        </li>
      }
    }
  </ul>
</div>
